<mat-card>
  <mat-card-header>
    <mat-card-title class="mat-card-title-custom">
      {{'enterprise_document_template.screen_name' | translate}}</mat-card-title>
  </mat-card-header>

  <mat-card-content class="mb-3 mat-card-content-contract-sm">
    <!-- THÔNG TIN TÌM KIẾM -->
    <mat-accordion>
      <!-- Search Form -->
      <mat-expansion-panel expanded="true" class="mt-3">
        <mat-expansion-panel-header>
          <mat-panel-title class="mat-panel-title">
            {{'enterprise_document_template.ttl_search' | translate}}
          </mat-panel-title>
        </mat-expansion-panel-header>
        <form #myForm="ngForm" (ngSubmit)="onFilterData(0, paginate.pageSize)">
          <div class="row">
            <div class="col-lg-4 col-md-6">
              <!--Document's name or code-->
              <mat-form-field class="w-100">
                <input (focusout)="documents.nameOrCode = documents.nameOrCode.trim()" #focusInput matInput type="text"
                  [placeholder]="'enterprise_document_template.lbl_document_name_code' | translate"
                  name="documentNameOrCode" [(ngModel)]="documents.nameOrCode" maxlength="200" autocomplete="off" />
                <button mat-button *ngIf="documents.nameOrCode" type="button" matSuffix mat-icon-button aria-label="Clear"
                  (click)="documents.nameOrCode=''">
                  <mat-icon>close</mat-icon>
                </button>
              </mat-form-field>
            </div>
            <div class="col-lg-3">
              <!--Document's status-->
              <mat-form-field class="w-100">
                <mat-label>{{'enterprise_document_template.cbx_document_status.lbl_document_status' | translate}}
                </mat-label>
                <mat-select #statusSelect (focusout)="(checkFocus = true)" (selectionChange)="checkFocus = false"
                  (focus)="commonService.openComboBox(checkFocus, statusSelect)" id="status" name="status"
                  [(ngModel)]="documents.status">
                  <mat-option value="null" selected (click)="this.commonService.closeDropdownList(this.statusSelect)">
                    {{'enterprise_document_template.cbx_document_status.cbx_document_status_select_all' | translate}}
                  </mat-option>
                  <mat-option value="true" (click)="this.commonService.closeDropdownList(this.statusSelect)">
                    {{'enterprise_document_template.cbx_document_status.cbx_document_status_active' | translate}}
                  </mat-option>
                  <mat-option value="false" (click)="this.commonService.closeDropdownList(this.statusSelect)">
                    {{'enterprise_document_template.cbx_document_status.cbx_document_status_inactive' | translate}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <div class="col-lg-3 d-flex justify-content-center">
              <div class="w-100 center-vertical">
                <button mat-stroked-button color="primary" type="submit" (click)="onClickBtnFilter()" [disabled]="isTableLoading">
                  <mat-icon class="mr-0" style="font-weight: 900;">search</mat-icon>
                  {{'enterprise_document_template.buttons.search' | translate}}
                </button>
              </div>
            </div>
          </div>
        </form>
      </mat-expansion-panel>
    </mat-accordion>

    <!-- DANH SÁCH MẪU HĐ -->
    <mat-accordion #accordion="matAccordion" [multi]="true">
      <mat-expansion-panel expanded="true" class="mt-3">

        <mat-panel-title class="mat-panel-title mb-2 mt-3 d-flex justify-content-between align-items-center">
          <span>{{'title.document_type_list' | translate}} ({{paginate.totalRow}})</span>
          <button class="pull-right" mat-stroked-button color="primary" (click)="openDialogAdd()">
            <mat-icon class="mr-0">add_circle</mat-icon>{{'enterprise_document_template.buttons.add' | translate}}
          </button>
        </mat-panel-title>

        <div class="mat-table-container">
          <mat-table [dataSource]="dataSource" matSort (matSortChange)="sortData($event)">

            <!-- STT -->
            <ng-container matColumnDef="STT">
              <mat-header-cell *matHeaderCellDef class="mat-header-cell-center no-col mat-cell-non-boder-right-bottom">
                <div class="stt-special">{{'enterprise_contract.table_headers.No' | translate}}</div>
              </mat-header-cell>
              <mat-cell *matCellDef="let element" class="mat-header-cell-center no-col mat-cell-non-boder-right-bottom"
                (click)="$event.stopPropagation()" style="max-width: 50px">
                {{element.STT}}
              </mat-cell>
              <mat-footer-cell *matFooterCellDef class="skeleton-footer-cell no-col" style="max-width: 50px">
                <span class="skeleton-cell"></span>
              </mat-footer-cell>
            </ng-container>

            <!-- Mẫu tài liệu Column -->
            <ng-container matColumnDef="name">
              <mat-header-cell *matHeaderCellDef mat-sort-header style="width: 30%"
                class="special mat-header-cell-center mat-cell-non-boder-right-bottom">
                <div class="name-special">{{'enterprise_document_template.table_headers.document_type' | translate}}
                </div>
              </mat-header-cell>
              <mat-cell *matCellDef="let element" class="mat-cell-non-boder-right-bottom" style="width: 30%">
                <button *ngIf="element.hasChildren" (click)="expandedParent(element.id)" mat-icon-button color="primary"
                  [matTooltip]="!element.close?('enterprise_document_template.tooltips.btn_expand_more' | translate) : ('enterprise_document_template.tooltips.btn_expand_less' | translate)">
                  <mat-icon id="expand_more" mat #expand_more *ngIf="!element.close">add</mat-icon>
                  <mat-icon id="expand_less" #expand_less *ngIf="element.close">remove</mat-icon>
                </button>
                <button *ngIf="!element.hasChildren" id="noSpanTable" (click)="closeExpandCollapse(element.id)"
                  style="cursor: context-menu;" mat-icon-button color="primary">
                </button>
                <span matTooltip="{{element.code}} - {{element.name}}" (click)="$event.stopPropagation()"
                  class="fix-width">
                  {{element.code}} - {{element.name}}</span>
              </mat-cell>
              <mat-footer-cell *matFooterCellDef class="skeleton-footer-cell" style="width: 30%">
                <span class="skeleton-cell"></span>
              </mat-footer-cell>
            </ng-container>

            <!-- Mô tả Column -->
            <ng-container matColumnDef="description">
              <mat-header-cell *matHeaderCellDef mat-sort-header
                class="special mat-header-cell-center mat-cell-non-boder-bottom">
                {{'enterprise_document_template.table_headers.document_description' | translate}}
              </mat-header-cell>
              <mat-cell *matCellDef="let element" matTooltip="{{element.description}}"
                class="mat-cell-non-boder-right-bottom" (click)="$event.stopPropagation()">
                <span class="fix-width">{{element.description}}</span>
              </mat-cell>
              <mat-footer-cell *matFooterCellDef class="skeleton-footer-cell">
                <span class="skeleton-cell"></span>
              </mat-footer-cell>
            </ng-container>

            <!-- Trạng thái Column -->
            <ng-container matColumnDef="status">
              <mat-header-cell *matHeaderCellDef
                class="special mat-header-cell-center status-col mat-cell-non-boder-right-bottom">
                <div class="status-special">{{'enterprise_document_template.table_headers.document_status' | translate}}
                </div>
              </mat-header-cell>
              <!-- [matTooltip]="element.status? ('enterprise_document_template.tooltips.icon_status_active' | translate) + '&#13;'+ ('enterprise_group_user_management.tooltips.click_change_status' | translate)
                : ('enterprise_document_template.tooltips.icon_status_inactive' | translate) + '&#13;'+ ('enterprise_group_user_management.tooltips.click_change_status' | translate)" -->
              <mat-cell *matCellDef="let element; let index = index" matTooltipClass="matTooltipBreakLine"
                class="mat-header-cell-center status-col mat-cell-non-boder-right-bottom"
                [matTooltip]="element.status? ('enterprise_document_template.tooltips.icon_status_active' | translate) : ('enterprise_document_template.tooltips.icon_status_inactive' | translate) ">
                <button mat-icon-button (click)="onChangeStatus(element.id,'',element.name,element.status)">
                  <mat-icon *ngIf="!element.status">lock</mat-icon>
                  <mat-icon *ngIf="element.status">lock_open</mat-icon>
                </button>
              </mat-cell>
              <mat-footer-cell *matFooterCellDef class="skeleton-footer-cell status-col">
                <span class="skeleton-cell"></span>
              </mat-footer-cell>
            </ng-container>

            <!-- auto sign -->
            <ng-container matColumnDef="isAutoSign">
              <mat-header-cell *matHeaderCellDef class="sign-special auto-sign-col">
                <div class="special-container">
                  {{'enterprise_document_template.table_headers.document_auto_sign_stutus' | translate}}</div>
              </mat-header-cell>
              <mat-cell *matCellDef="let element; let index = index"
                class="mat-header-cell-center auto-sign-col mat-cell-non-boder-right-bottom"
                (click)="$event.stopPropagation()" [matTooltip]="
                    element.isAutoSign ? ('enterprise_document_template.tooltips.btn_auto_sign_off' | translate)
                  : ('enterprise_document_template.tooltips.btn_auto_sign_on' | translate)
                ">
                <button *ngIf="element.isAutoSign" mat-icon-button
                  (click)="onSetAutoSign(element.id, element.isAutoSign,null,element.name)">
                  <mat-icon color="primary">check_box
                  </mat-icon>
                </button>
                <button *ngIf="!element.isAutoSign" mat-icon-button
                  (click)="onSetAutoSign(element.id, element.isAutoSign,null,element.name)">
                  <mat-icon color="primary">check_box_outline_blank
                  </mat-icon>
                </button>
              </mat-cell>
              <mat-footer-cell *matFooterCellDef class="skeleton-footer-cell auto-sign-col">
                <span class="skeleton-cell"></span>
              </mat-footer-cell>
            </ng-container>

            <!-- sign otp -->
            <ng-container matColumnDef="isOtpSign">
              <mat-header-cell *matHeaderCellDef class="sign-otp-special sign-otp-col ">
                <div class="special-container">
                  {{'enterprise_document_template.table_headers.document_otp_sign_status' | translate}}</div>
              </mat-header-cell>
              <mat-cell *matCellDef="let element"
                class="mat-header-cell-center sign-otp-col mat-cell-non-boder-right-bottom"
                (click)="$event.stopPropagation()" [matTooltip]="element.isOtpSign && element.relationOtpSign ? ('enterprise_document_template.tooltips.icon_sign_otp_on' | translate)
                  : ('enterprise_document_template.tooltips.icon_sign_otp_off' | translate)">
                <button mat-icon-button *ngIf="getOtpSignStatus(element)" (click)="onSetSignOTP(element)">
                  <mat-icon color="primary">check_box
                  </mat-icon>
                </button>
                <button mat-icon-button *ngIf="!getOtpSignStatus(element)" (click)="onSetSignOTP(element)">
                  <mat-icon color="primary">check_box_outline_blank
                  </mat-icon>
                </button>
              </mat-cell>
              <mat-footer-cell *matFooterCellDef class="skeleton-footer-cell sign-otp-col">
                <span class="skeleton-cell"></span>
              </mat-footer-cell>
            </ng-container>

            <!-- sign cts -->
            <!-- Khách hàng bảo thêm cột này cho rõ nghĩa -->
            <ng-container matColumnDef="CTS">
              <mat-header-cell *matHeaderCellDef class="sign-cts-special sign-otp-col ">
                <div class="special-container">
                  {{'enterprise_document_template.table_headers.document_cts_sign_status' | translate}}</div>
              </mat-header-cell>
              <mat-cell *matCellDef="let element"
                class="mat-header-cell-center sign-otp-col mat-cell-non-boder-right-bottom"
                (click)="$event.stopPropagation()">
                <button mat-icon-button disabled>
                  <mat-icon>check_box</mat-icon>
                </button>
              </mat-cell>
              <mat-footer-cell *matFooterCellDef class="skeleton-footer-cell sign-otp-col">
                <span class="skeleton-cell"></span>
              </mat-footer-cell>
            </ng-container>

            <!-- Tác động Column -->
            <ng-container matColumnDef="action" class="mat-column-symbol  ">
              <mat-header-cell *matHeaderCellDef
                class="special mat-header-cell-center action-col mat-cell-non-boder-bottom">
                <div class="status-special">{{'headertable.action' | translate}}</div>
              </mat-header-cell>
              <mat-cell *matCellDef="let element; let index = index"
                class="special mat-header-cell-center action-col mat-cell-non-boder-bottom"
                (click)="$event.stopPropagation()">
                <button mat-icon-button (click)="viewHtml(element.id, element.name)">
                  <mat-icon
                    matTooltip="{{'enterprise_document_template.tooltips.btn_view' | translate}}">
                    visibility</mat-icon>
                </button>

                <button mat-icon-button (click)="openDialogUpdate(element.id)">
                  <mat-icon
                    matTooltip="{{'enterprise_document_template.tooltips.btn_edit' | translate}}">
                    edit</mat-icon>
                </button>
              </mat-cell>
              <mat-footer-cell *matFooterCellDef class="skeleton-footer-cell action-col">
                <span class="skeleton-cell"></span>
              </mat-footer-cell>
            </ng-container>

            <!-- mat-header-cell second -->
            <!-- STT -->
            <ng-container matColumnDef="STTSecond">
              <mat-header-cell *matHeaderCellDef class="mat-header-cell-center no-col mat-cell-non-boder-right-bottom">
              </mat-header-cell>
              <mat-footer-cell *matFooterCellDef class="skeleton-footer-cell no-col">
                <span class="skeleton-cell"></span>
              </mat-footer-cell>
            </ng-container>

            <!-- Mẫu tài liệu Column -->
            <ng-container matColumnDef="nameSecond">
              <mat-header-cell *matHeaderCellDef style="width: 30%"
                class="mat-header-cell-center mat-cell-non-boder-right-bottom">
              </mat-header-cell>
              <mat-footer-cell *matFooterCellDef class="skeleton-footer-cell" style="width: 30%">
                <span class="skeleton-cell"></span>
              </mat-footer-cell>
            </ng-container>

            <!-- Mô tả Column -->
            <ng-container matColumnDef="descriptionSecond">
              <mat-header-cell *matHeaderCellDef class="mat-header-cell-center mat-cell-non-boder-bottom">
              </mat-header-cell>
              <mat-footer-cell *matFooterCellDef class="skeleton-footer-cell">
                <span class="skeleton-cell"></span>
              </mat-footer-cell>
            </ng-container>
            <!-- Trạng thái Column -->
            <ng-container matColumnDef="sumSecond">
              <mat-header-cell *matHeaderCellDef class="mat-header-cell-center sum-col sign-way">
                {{'enterprise-certificate_management.cbx_certificate_type.lbl_certificate_type' | translate}}
              </mat-header-cell>
              <mat-footer-cell *matFooterCellDef class="skeleton-footer-cell">
                <span class="skeleton-cell"></span>
              </mat-footer-cell>
            </ng-container>
            <!-- Sign otp -->
            <ng-container matColumnDef="statusSecond">
              <mat-header-cell *matHeaderCellDef
                class="mat-header-cell-center sign-otp-col mat-cell-non-boder-right-bottom">
              </mat-header-cell>
              <mat-footer-cell *matFooterCellDef class="skeleton-footer-cell">
                <span class="skeleton-cell"></span>
              </mat-footer-cell>
            </ng-container>

            <!-- Tác động Column -->
            <ng-container matColumnDef="symbolSecond" class="mat-column-symbol  ">
              <mat-header-cell *matHeaderCellDef class="mat-header-cell-center action-col mat-cell-non-boder-bottom">
              </mat-header-cell>
              <mat-footer-cell *matFooterCellDef class="skeleton-footer-cell">
                <span class="skeleton-cell"></span>
              </mat-footer-cell>
            </ng-container>

            <mat-header-row class="row-special " *matHeaderRowDef="displayedColumnsSecond; sticky: true">
            </mat-header-row>
            <mat-header-row class="row-specialSecond " *matHeaderRowDef="displayedColumns; sticky: true">
            </mat-header-row>
            <mat-row *matRowDef="let row; columns: displayedColumns;" matRipple class="element-row" [cdkDetailRow]="row"
              [cdkDetailRowTpl]="tpl" (toggleChange)="onToggleChange($event,row)">
            </mat-row>
            <!-- hang skeleton trong bang: mat-footer-row render doc lap voi data nen ton tai
                 ca khi bang chua co du lieu; moi cot co mat-footer-cell rieng theo dung cot;
                 an/hien qua class theo isTableLoading -->
            <mat-footer-row *matFooterRowDef="displayedColumns"
                            class="table-skeleton-row"
                            [class.table-skeleton-hidden]="!isTableLoading"></mat-footer-row>
          </mat-table>
        </div>

        <ng-template #tpl let-element>
          <div [ngClass]="show? 'detail-row' : 'no-span-div'" class="mat-row" [@detailExpand] style="overflow: hidden">
            <!-- add child table here !!! -->
            <mat-table *ngIf="show" [dataSource]="childDataSourceList[element.id]" class="child-left"
              #child_{{element.id}}="matSort" matSort (matSortChange)="sortChildData($event, element.id)">

              <!-- STT -->
              <ng-container matColumnDef="STT">
                <mat-header-cell *matHeaderCellDef
                  class="mat-header-cell-center no-col mat-cell-non-boder-right-bottom">
                  {{'enterprise_contract.table_headers.No' | translate}}
                </mat-header-cell>
                <mat-cell *matCellDef="let elementChild"
                  class="mat-header-cell-center no-col mat-cell-non-boder-right-bottom"
                  (click)="$event.stopPropagation()">
                  {{element.STT}}.{{elementChild.STT}}
                </mat-cell>
                <mat-footer-cell *matFooterCellDef class="skeleton-footer-cell no-col">
                  <span class="skeleton-cell"></span>
                </mat-footer-cell>
              </ng-container>

              <!-- Mẫu tài liệu Column -->
              <ng-container matColumnDef="name">
                <mat-header-cell *matHeaderCellDef mat-sort-header style="width: 30%"
                  class="mat-cell-non-boder-right-bottom">
                  {{'enterprise_document_template.table_headers.document_type' | translate}}
                </mat-header-cell>
                <mat-cell *matCellDef="let element" matTooltip="{{ element.code}} - {{element.name}}"
                  style="width: 30%" class="mat-cell-non-boder-right-bottom">
                  <button style="cursor: context-menu;" mat-icon-button color="primary">
                  </button>
                  <button color="primary" style="cursor: context-menu;" mat-icon-button>
                    <mat-icon id="expand_more" mat>subdirectory_arrow_right</mat-icon>
                  </button>
                  <span class="fix-width">{{ element.code}} - {{element.name}}</span>
                </mat-cell>
                <mat-footer-cell *matFooterCellDef class="skeleton-footer-cell" style="width: 30%">
                  <span class="skeleton-cell"></span>
                </mat-footer-cell>
              </ng-container>

              <!-- Mô tả Column -->
              <ng-container matColumnDef="description">
                <mat-header-cell *matHeaderCellDef mat-sort-header class="mat-cell-non-boder-right-bottom">
                  {{'enterprise_document_template.table_headers.document_description' | translate}}
                </mat-header-cell>
                <mat-cell *matCellDef="let element" matTooltip="{{ element.description }}"
                  class="mat-cell-non-boder-right-bottom">
                  <span class="fix-width">{{ element.description}}</span>
                </mat-cell>
                <mat-footer-cell *matFooterCellDef class="skeleton-footer-cell">
                  <span class="skeleton-cell"></span>
                </mat-footer-cell>
              </ng-container>

              <!-- Trạng thái Column -->
              <ng-container matColumnDef="status">
                <mat-header-cell *matHeaderCellDef
                  class="mat-header-cell-center status-col mat-cell-non-boder-right-bottom">
                  {{'enterprise_document_template.table_headers.document_status' | translate}}
                </mat-header-cell>
                <mat-cell *matCellDef="let element"
                  class="mat-header-cell-center status-col mat-cell-non-boder-right-bottom">
                  <button mat-icon-button
                    (click)="onChangeStatus(element.id, element.parentId, element.name, element.status)">
                    <mat-icon *ngIf="!element.status"
                      [matTooltip]="'enterprise_document_template.tooltips.icon_status_inactive' | translate">lock
                    </mat-icon>
                    <mat-icon *ngIf="element.status"
                      [matTooltip]="'enterprise_document_template.tooltips.icon_status_active' | translate">lock_open
                    </mat-icon>
                  </button>
                </mat-cell>
                <mat-footer-cell *matFooterCellDef class="skeleton-footer-cell">
                  <span class="skeleton-cell"></span>
                </mat-footer-cell>
              </ng-container>

              <!-- auto sign -->
              <ng-container matColumnDef="isAutoSign">
                <mat-header-cell *matHeaderCellDef class="sign-special auto-sign-col">
                  {{'enterprise_document_template.table_headers.document_auto_sign_stutus' | translate}}
                </mat-header-cell>
                <mat-cell *matCellDef="let element"
                  class="mat-header-cell-center auto-sign-col mat-cell-non-boder-right-bottom" [matTooltip]="
                      element.isAutoSign ? ('enterprise_document_template.tooltips.btn_auto_sign_off' | translate)
                    : ('enterprise_document_template.tooltips.btn_auto_sign_on' | translate)
                  ">
                  <button mat-icon-button color="primary"
                    (click)="onSetAutoSign(element.id, element.isAutoSign, element.parentId, element.name)">
                    <mat-icon *ngIf="element.isAutoSign">check_box</mat-icon>
                    <mat-icon *ngIf="!element.isAutoSign">check_box_outline_blank
                    </mat-icon>
                  </button>
                </mat-cell>
                <mat-footer-cell *matFooterCellDef class="skeleton-footer-cell">
                  <span class="skeleton-cell"></span>
                </mat-footer-cell>
              </ng-container>

              <!-- sign otp -->
              <ng-container matColumnDef="isOtpSign">
                <mat-header-cell *matHeaderCellDef class="sign-special sign-otp-col">
                  {{'enterprise_document_template.table_headers.document_otp_sign_status' | translate}}
                </mat-header-cell>
                <mat-cell *matCellDef="let elementChild; let index = index"
                  class="mat-header-cell-center sign-otp-col mat-cell-non-boder-right-bottom"
                  (click)="$event.stopPropagation()" [matTooltip]="element.isOtpSign && element.relationOtpSign ? ('enterprise_document_template.tooltips.icon_sign_otp_on' | translate)
                    : ('enterprise_document_template.tooltips.icon_sign_otp_off' | translate)">
                  <button mat-icon-button *ngIf="getOtpSignStatus(elementChild)" (click)="onSetSignOTP(elementChild)">
                    <mat-icon color="primary">check_box
                    </mat-icon>
                  </button>
                  <button mat-icon-button *ngIf="!getOtpSignStatus(elementChild)" (click)="onSetSignOTP(elementChild)">
                    <mat-icon color="primary">check_box_outline_blank
                    </mat-icon>
                  </button>
                </mat-cell>
                <mat-footer-cell *matFooterCellDef class="skeleton-footer-cell">
                  <span class="skeleton-cell"></span>
                </mat-footer-cell>
              </ng-container>

              <!-- sign CTS -->
              <!-- Khách hàng bảo thêm cột này cho rõ nghĩa -->
              <ng-container matColumnDef="CTS">
                <mat-header-cell *matHeaderCellDef class="sign-special sign-otp-col">
                  {{'enterprise_document_template.table_headers.document_cts_sign_status' | translate}}
                </mat-header-cell>
                <mat-cell *matCellDef="let element"
                  class="mat-header-cell-center sign-otp-col mat-cell-non-boder-right-bottom"
                  (click)="$event.stopPropagation()">
                  <button mat-icon-button disabled>
                    <mat-icon>check_box</mat-icon>
                  </button>
                </mat-cell>
                <mat-footer-cell *matFooterCellDef class="skeleton-footer-cell">
                  <span class="skeleton-cell"></span>
                </mat-footer-cell>
              </ng-container>

              <!-- Tác động Column -->
              <ng-container matColumnDef="symbol" class="mat-column-symbol">
                <mat-header-cell *matHeaderCellDef class="mat-header-cell-center action-col mat-cell-non-boder-bottom">
                  {{'headertable.action' | translate}}
                </mat-header-cell>
                <mat-cell *matCellDef="let element" class="mat-header-cell-center action-col mat-cell-non-boder-bottom">
                  <button mat-icon-button (click)="viewHtml(element.id,element.name)">
                    <mat-icon matTooltip="{{'enterprise_document_template.tooltips.btn_view' | translate}}">visibility
                    </mat-icon>
                  </button>
                  <button mat-icon-button (click)="openDialogUpdate(element.id)">
                    <mat-icon matTooltip="{{'enterprise_document_template.tooltips.btn_edit' | translate}}">edit
                    </mat-icon>
                  </button>
                </mat-cell>
                <mat-footer-cell *matFooterCellDef class="skeleton-footer-cell">
                  <span class="skeleton-cell"></span>
                </mat-footer-cell>
              </ng-container>

              <mat-header-row *matHeaderRowDef="displayedColumnsChild"
                style="display: none !important; padding: 0px !important;"></mat-header-row>
              <mat-row *matRowDef="let row; columns: displayedColumnsChild;">
              </mat-row>
            </mat-table>
          </div>
        </ng-template>

        <!-- Pagination -->
        <app-pagination [(paginate)]="paginate" (pageChange)="onFilterData($event.page, $event.pageSize)"
                        [isShowNoRecord]="!isTableLoading">
        </app-pagination>

      </mat-expansion-panel>
    </mat-accordion>

  </mat-card-content>
</mat-card>
